import { render, staticRenderFns } from "./ReportDownloads.vue?vue&type=template&id=3f6939a1&scoped=true&"
import script from "./ReportDownloads.vue?vue&type=script&lang=js&"
export * from "./ReportDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6939a1",
  null
  
)

export default component.exports